"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPhotoCarousel = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PhotoCarouselMixin = require("../../mixins/components/PhotoCarouselMixin");
var StyledPhotoCarousel = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledPhotoCarousel",
  componentId: "c11n-8-107-0__sc-2dw10y-0"
})(["", ""], _PhotoCarouselMixin.PhotoCarouselMixin);
exports.StyledPhotoCarousel = StyledPhotoCarousel;